import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { RedirectWithTrailingSlash } from "./RedirectWithTrailingSlash";

export function PublicRoute(props) {
  return (
    <>
      <div className="publicBody">
        <Route {...props} render={(props) => <Component {...props} />} />
        <RedirectWithTrailingSlash from="/:path(.*?)/" to="/:path" />
      </div>
    </>
  );
}

export default PublicRoute;
